module.exports = __webpack_public_path__ + "media/images/country_flags/ly-7cf4bb4538fbdf5123e5db48aac23174.png";